module.exports = {
  __init__: [ 'zoomScroll' ],
  zoomScroll: [ 'type', require('./ZoomScroll') ]
};


// WEBPACK FOOTER //
// ./~/diagram-js/lib/navigation/zoomscroll/index.js